export const API_HOSTS = {
  STAGING: "https://api.stg-sentimeter.com/api",
  QA: "https://api.qa-sentimeter.com/api",
  PROD: "https://api.sentimeter.io/api",
  LOCAL: "http://localhost:8000/api",
};

export const baseURL = process.env.REACT_APP_SERVER_URL || API_HOSTS.STAGING;

export const ORGANIZATION_AUTH_URL = slug =>
  `/v1/organizations/verify/${slug}?features=app`;

export const TAG_LIST_URL = questionnaireId =>
  `/v1/users/tag-third-party/list?questionnaire_id=${questionnaireId}`;

export const TAKER_AUTH_URL = orgId => `/v1/users/auth?organization=${orgId}`;

export const TOKEN_REFRESH_URL = () => "v1/users/refresh-token";

export const POST_LOGIN_IMAGE = () => "v1/users/user-session";

export const GET_DIVISION_URL = (orgId, divisionId, groupId, takerId) =>
  `/v1/organizations/${orgId}/divisions/${divisionId}/detail?group=${groupId}&taker=${takerId}`;

export const GET_EMBED_SURVEY_DIVISION_URL = (orgId, divisionQureyString) =>
  `/v1/organizations/${orgId}/divisions/get?level_division_str=${divisionQureyString}`;

export const GET_QUESTIONNAIRES_URL = (orgId, takerType, groupId) =>
  `/organizations/${orgId}/questionnaires/v2/list/?type=${takerType}&group=${groupId}`;

export const SURVEY_INVITES_URL = hash =>
  `/customers/survey-invites/v2/${hash}`;

export const FEEDBACK_SUBMIT_URL = id =>
  `/organizations/${id}/feedback/v3/create`;

export const FEEDBACK_REVIEW_URL = (id, feedback_options) =>
  `/organizations/${id}/feedback/v3/generate-review?feedback_options=${feedback_options}`;

export const FEEDBACK_UPDATE_URL = (orgId, feedbackId) =>
  `/organizations/${orgId}/feedback/v1/${feedbackId}/update/`;

export const VERSION_CHECK_URL = OS =>
  `/v1/organizations/apps/versions/verify?platform=${OS}`;

export const APP_UPDATE_URL = OS =>
  OS === "ios"
    ? "itms-apps://itunes.apple.com/us/app/apple-store/id1351265758?mt=8"
    : "https://play.google.com/store/apps/details?id=com.sentimeterNode";

export const HELP_DESK_URL =
  "https://sentimeter.atlassian.net/servicedesk/customer/portal/1/create/1";

export const PRIVACY_POLICY_URL = "https://sentimeter.io/data-privacy-policy/";

export const GET_QUESTIONNAIRE_URL = (orgId, questionnaireId) =>
  `/organizations/${orgId}/questionnaires/v3/${questionnaireId}/detail/`;

export const SURVEY_OPEN_SIGNAL_URL = "/customers/invite-analytics/";
